<template>
<v-layout>
  <table border="0">
    <thead style="height:0px;display:hidden">
      <tr>
        <th style="width:5%;height:0px">day</th>
        <th style="width:20%;height:0px">점검일</th>
        <th style="width:15%;height:0px">충전소</th>
        <th style="width:20%;height:0px">충전기</th>
        <th style="width:10%;height:0px">이상 유무</th>
        <th style="width:30%;height:0px">충전소 위치 / 점검 위치</th>
        <!--
        <th style="width:5%">day</th>
        <th style="width:10%">점검일</th>
        <th style="width:10%">충전소</th>
        <th style="width:10%">충전기</th>
        <th style="width:5%">첨부사진</th>
        <th style="width:10%">메인스위치(좌:우)</th>
        <th style="width:10%">타이머(좌:우)</th>
        <th style="width:10%">로드선(좌:우)</th>
        <th style="width:10%">스위치(좌:우)</th>
        <th style="width:10%">에어(좌:우)</th>
        <th style="width:10%">기타(좌:우)</th>
        -->
      </tr>
    </thead>
    <tbody>
      <template v-for="(date, index) in dates">
        <template v-if="$_getDailyReportLength(date) > 0">
          <template v-for="(report, rowIndex) in $_getDailyReports(date)">
            <tr :key="index + '-' + rowIndex">
              <th v-if="rowIndex == 0"
                :class="$_getDayClass(date)"
                :rowspan="$_getDailyReportLength(date)">
                {{index + 1}}
              </th>

              <td>{{ $_getReportDate(report) }}</td>
              <td>{{ report.place ? report.place.name : '' }}</td>
              <td>{{ report.charger ? report.charger.managementNumber : '' }}</td>
              <!--
              <td><v-icon v-if="report.pictureUrls && report.pictureUrls.length > 0"
                  @click="dialog = true; selectedReport = report">photo</v-icon></td>

              <td v-html="$_getCheckResultHtml(report.checkItems, '메인스위치')"></td>
              <td v-html="$_getCheckResultHtml(report.checkItems, '타이머')"></td>
              <td v-html="$_getCheckResultHtml(report.checkItems, '로드선')"></td>
              <td v-html="$_getCheckResultHtml(report.checkItems, '스위치')"></td>
              <td v-html="$_getCheckResultHtml(report.checkItems, '에어')"></td>
              <td v-html="$_getCheckResultHtml(report.checkItems, '기타')"></td>
              -->
              <td v-if="report.checkResult"
                style="cursor: pointer"
                @click="dialogReport = true; selectedReport = report">
                <span style="text-decoration: underline">이상 없음</span>
              </td>
              <td v-else
                style="background-color:orange; cursor:pointer"
                @click="dialogReport = true; selectedReport = report">
                <span style="text-decoration: underline">고장</span>
              </td>

              <td><a @click="$_openMapByAddress(report)">{{report.place.address}}</a><br>
                <a @click="$_openMapByAddress(report)" :id="'reportLink_' + report.id">
                  {{$_getReportedAddress(report, true)}}
                </a>
              </td>
            </tr>
          </template>
        </template>
        <tr v-else :key="index">
          <th :class="$_getDayClass(date)">
            {{index + 1}}
          </th>
          <td colspan="10">
          </td>
        </tr>
      </template>
    </tbody>
  </table>
  <v-dialog
    v-model="dialog"
    width="700">
    <v-card>
      <v-carousel v-if="selectedReport && selectedReport.pictureUrls && selectedReport.pictureUrls.length > 0">
        <v-carousel-item v-for="(value, key) in selectedReport.pictureUrls"
          :src="value" :lazy-src="value" :key="key">
          <template v-slot:placeholder>
            <v-layout
              fill-height
              align-center
              justify-center
              ma-0>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </template>
        </v-carousel-item>
      </v-carousel>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogReport"
    width="500">
    <report-card v-if="selectedReport" :report="selectedReport" />
  </v-dialog>
</v-layout>
</template>

<script>
// import firebase from 'firebase'
import moment from 'moment'
import ReportCard from './ReportCard'
import axios from 'axios'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import {Util} from '../Util'

export default {
  name: 'ReportMonthlyList',
  components: {
    'report-card': ReportCard
  },
  props: {
    reports: {
      type: Array,
      default () {
        return []
      }
    },
    initStart: {
      type: String,
      default () {
        return moment().startOf('month').format('YYYY-MM')
      }
    }
  },
  data () {
    return {
      dialog: false,
      dialogReport: false,
      selectedReport: null,
      start: moment(this.initStart).startOf('month').format('YYYY-MM-DD'),
      end: moment(this.start).endOf('month').format('YYYY-MM-DD')
    }
  },
  computed: {
    checkItems () {
      const checkItemSet = new Set()

      this.reports.forEach(report => {
        for (var key in report.checkItems) {
          checkItemSet.add(key)
        }
      })

      return Array.from(checkItemSet).sort()
    },
    dates () {
      const dates = []

      for (let i = 0; i < moment(this.start).daysInMonth(); i++) {
        dates[i] = moment(this.start).add(i, 'day').format('YYYY-MM-DD')
      }

      return dates
    },
    // convert the list of reports into a map of lists keyed by date
    reportsMap () {
      const map = {}
      this.reports.forEach(e => (map[e.date] = map[e.date] || []).push(e))
      return map
    }
  },
  methods: {
    /*
    $_isOkCheckItem (key, value) {
      if (value === '정상' || (key === '장애물' && value === '없음')) {
        return true
      }

      return false
    },
    $_getCheckItems () {
      const checkItemSet = new Set()

      this.reports.forEach(report => {
        for (var key in report.checkItems) {
          checkItemSet.add(key)
        }
      })

      return Array.from(checkItemSet).sort()
    },
    */
    $_getCheckResultHtml (checkItem, key) {
      return '<span style="color:' + (checkItem['충전기(좌)'][key] === '고장' ? 'red' : '') + '">' + checkItem['충전기(좌)'][key] + '</span>' +
            ' : ' +
            '<span style="color:' + (checkItem['충전기(우)'][key] === '고장' ? 'red' : '') + '">' + checkItem['충전기(우)'][key] + '</span>'
    },
    $_getDailyReports (date) {
      return this.reportsMap[date]
    },
    $_getDailyReportLength (date) {
      return this.reportsMap[date] ? this.reportsMap[date].length : 0
    },
    $_getReportDate (report) {
      return moment(report.created.toDate()).format('YYYY-MM-DD HH:mm')
    },
    $_getDayClass (date) {
      return moment(date, 'YYYY-MM-DD').format('ddd').toLowerCase()
    },
    $_getReportedAddress (report, setKakao) {
      if (!report.kakaoAddress) {
        console.log('find not kakaoAddress')

        if (setKakao) {
          this.$_setKakaoAddress(report)
        }
      }

      return Util.getReadableReportAddress(report)
    },
    async $_setKakaoAddress (report) {
      // GET https://dapi.kakao.com/v2/local/geo/coord2address.json?x=127.423084873712&y=37.0789561558879&input_coord=WGS84
      // Authorization: KakaoAK 7c2ad90fe9a5a79d870cca77990c9d3c

      try {
        if (report.location) {
          // console.log(report)

          const longitude = report.location.longitude
          const latitude = report.location.latitude
          const url = 'https://dapi.kakao.com/v2/local/geo/coord2address.json?x=' + longitude + '&y= ' + latitude + '&input_coord=WGS84'
          const response = await axios.get(url, { headers: {'Authorization': 'KakaoAK 7c2ad90fe9a5a79d870cca77990c9d3c'} })

          // snap.ref.set({'kakaoAddress': response.data}, {merge: true})
          // console.log(response)
          // return response.data

          report.kakaoAddress = response.data
          document.getElementById('reportLink_' + report.id).innerHTML = this.$_getReportedAddress(report, false)

          this.$fs.collection('reports')
            .doc(report.id)
            .set({kakaoAddress: response.data,
              updated: firebase.firestore.FieldValue.serverTimestamp()}, {merge: true})
            .then(() => {
              // 로컬 데이터 업데이트
              // Object.assign(this.datas[this.editedIndex], this.editedItem)
            }).catch((error) => {
              console.error('Error adding document: ', error)
            })
        }
      } catch (error) {
        if (error) {
          console.log(error)
        }
      }
    },
    $_openMapByAddress (report) {
      const address = report.place.address
      let address2 = this.$_getReportedAddress(report, false)

      if (address && address2) {
        window.open('https://www.google.com/maps/dir/?api=1&origin=' + address + '&destination=' + address2 + '&travelmode=walking')
      } else if (address) {
        window.open('https://www.google.com/maps/search/?api=1&query=' + address)
      }
    },
    $_openMapByLocation (location) {
      // https://www.google.com/maps/search/?api=1&query=47.5951518,-122.3316393&query_place_id=ChIJKxjxuaNqkFQR3CK6O1HNNqY
      window.open('https://www.google.com/maps/search/?api=1&query=' + location.latitude + ',' + location.longitude)
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.report_ok {
  color:rgba(0,0,0,.87)
}

.report_error {
  color:red
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead th {
  height: 24px;
}

th, td {
  border: 1px solid darkgray;
  min-height: 20px;
  padding: 4px;
}

th.sat {
  color: blue;
}

th.sun {
  color: red;
}

td {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportMonthlyList.vue